import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AllStates, stateCodeToFullName } from 'utils/lib/types/common';
import { REQUIRED_FIELD_ERROR_MESSAGE } from 'utils/lib/validation/constants';
import { ZipInput } from './input/ZipInput';

export function AddressFields({
  requireFullZip,
  required = true,
}: {
  requireFullZip?: boolean;
  required?: boolean;
}): ReactElement {
  const { control } = useFormContext();
  return (
    <>
      <Controller
        name="line1"
        control={control}
        rules={{ required: required ? REQUIRED_FIELD_ERROR_MESSAGE : false }}
        render={({ field, fieldState: { error: fieldError } }) => (
          <TextField
            label={required ? 'Address 1 *' : 'Address 1'}
            size="small"
            fullWidth
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
            error={!!fieldError}
            helperText={fieldError?.message}
          />
        )}
      />
      <Controller
        name="line2"
        control={control}
        render={({ field, fieldState: { error: fieldError } }) => (
          <TextField
            label="Address 2"
            size="small"
            fullWidth
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
            error={!!fieldError}
            helperText={fieldError?.message}
          />
        )}
      />
      <Controller
        name="city"
        control={control}
        rules={{
          required: required ? REQUIRED_FIELD_ERROR_MESSAGE : false,
          validate: (value) => {
            if (!value) return true;
            if (value.length < 2) return 'Must be least 2 chars long';
            return true;
          },
        }}
        render={({ field, fieldState: { error: fieldError } }) => (
          <TextField
            label={required ? 'City *' : 'City'}
            size="small"
            fullWidth
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
            error={!!fieldError}
            helperText={fieldError?.message}
          />
        )}
      />
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Controller
          name="state"
          control={control}
          rules={{ required: required ? REQUIRED_FIELD_ERROR_MESSAGE : false }}
          render={({ field, fieldState: { error: fieldError } }) => (
            <FormControl size="small" fullWidth>
              <InputLabel id="state-select-label" error={!!fieldError}>
                {required ? 'State *' : 'State'}
              </InputLabel>
              <Select
                aria-describedby={fieldError ? 'state-helper-text' : undefined}
                label={required ? 'State *' : 'State'}
                labelId="state-select-label"
                size="small"
                fullWidth
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                error={!!fieldError}
              >
                {AllStates.map((state) => (
                  <MenuItem value={state.value} key={state.value}>
                    {stateCodeToFullName[state.value]}
                  </MenuItem>
                ))}
              </Select>
              {fieldError ? (
                <FormHelperText id={`state-helper-text`} error={true}>
                  {fieldError?.message}
                </FormHelperText>
              ) : (
                <></>
              )}
            </FormControl>
          )}
        />
        <ZipInput
          name="zip"
          label={required ? 'ZIP Code *' : 'ZIP Code'}
          required={required}
          requireFullZip={requireFullZip}
        />
      </Box>
    </>
  );
}
